import { renderSubscribedToVigboModal } from 'reactApp/ui/SubscribedToVigboModal/SubscribedToVigboModal.helper';

export interface SubscribedToVigboModalProps {
    onShow?: () => void;
    onClose?: () => void;
    onClick?: () => void;
}

export const openSubscribedToVigboModal = ({ onShow, onClose, onClick }: SubscribedToVigboModalProps) => {
    renderSubscribedToVigboModal({ onShow, onClose, onClick });
};
